import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

interface CustomTextFieldProps {
  customSize?: 'medium' | 'large' | 'default';
  multiline?: boolean;
}

const CustomTextField = styled((props: CustomTextFieldProps & any) => <TextField {...props} />)(
  ({ theme, customSize = 'default', multiline }) => {
    let fontSize;
    switch (customSize) {
      case 'medium':
        fontSize = '1rem';
        break;
      case 'large':
        fontSize = '1.2rem';
        break;
      default:
        fontSize = '0.8rem';
    }

    return {
      '& .MuiInputBase-root': {
        padding: multiline ? '0' : '',
        '&.MuiInputBase-multiline': {
          height: 'auto',
          minHeight: '40px'
        }
      },
      '& .MuiOutlinedInput-input': {
        padding: '8px 12px',
        fontSize: fontSize,
        '&.MuiInputBase-inputMultiline': {
          height: 'auto !important',
          minHeight: '40px !important',
          padding: '8px 12px'
        }
      },
      '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
        color: theme.palette.text.secondary,
        opacity: '0.8',
        fontSize: fontSize,
      },
      '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
        color: theme.palette.text.secondary,
        opacity: '1',
        fontSize: fontSize,
      },
      '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[200],
      },
    };
  }
);

export default CustomTextField;
